import React, { useEffect, useRef } from 'react';
import HeroSection from './sections/HeroSection';
import AboutSection from './sections/AboutSection';
import ApproachSection from './sections/ApproachSection';
import ProjectsSection from './sections/ProjectsSection';
import ContactSection from './sections/ContactSection';
import Navigation from './Navigation';
import './TaraVenturesWebsite.css';

const TaraVenturesWebsite = () => {
  const observerRef = useRef(null);

  useEffect(() => {
    // Intersection Observer for fade-in animations
    observerRef.current = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('fade-in-active');
          }
        });
      },
      {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px',
      }
    );

    // Observe all sections
    const sections = document.querySelectorAll('.observe-fade');
    sections.forEach((section) => {
      observerRef.current.observe(section);
    });

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect();
      }
    };
  }, []);

  return (
    <div className="tara-ventures-website">
      <Navigation />
      <HeroSection />
      <AboutSection />
      <ApproachSection />
      <ProjectsSection />
      <ContactSection />
    </div>
  );
};

export default TaraVenturesWebsite;